import { render, staticRenderFns } from "./MyOrganisation.vue?vue&type=template&id=072e5ea6&scoped=true"
import script from "./MyOrganisation.vue?vue&type=script&lang=js"
export * from "./MyOrganisation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e5ea6",
  null
  
)

export default component.exports